import { getFullNameFromUnknown, getStringFromRecord } from './_nameHelpers';

import { TicketDetail, TicketSummary } from '@/services/TicketsService';

export function getTicketCustomerName(
  ticket: TicketSummary | TicketDetail,
): string | undefined {
  const ticketRecord = ticket as unknown as Record<string, unknown>;

  const customerName =
    ticket.customerName?.trim() ||
    getStringFromRecord(ticketRecord, 'customerDisplayName') ||
    getStringFromRecord(ticketRecord, 'customerTradeName') ||
    getStringFromRecord(ticketRecord, 'customerLegalName') ||
    getStringFromRecord(ticketRecord, 'storeName') ||
    getStringFromRecord(ticketRecord, 'tenantName');

  if (customerName) {
    return customerName;
  }

  const customerRecord = ticketRecord.customer;

  if (!customerRecord || typeof customerRecord !== 'object') {
    return undefined;
  }

  const normalizedCustomerRecord = customerRecord as Record<string, unknown>;

  return (
    getStringFromRecord(normalizedCustomerRecord, 'tradeName') ||
    getStringFromRecord(normalizedCustomerRecord, 'legalName') ||
    getFullNameFromUnknown(customerRecord)
  );
}
